import { useFormStore } from "~/store/formStore";

export const modalFormStore = useFormStore("modal");
